var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 1117,
    viewBox: "0 0 576 1117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -24,
    cy: 559,
    r: 600,
    fill: "#EDFFF9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -200,
    cy: 559,
    r: 600,
    fill: "#A7FFDF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: -406,
    cy: 559,
    r: 600,
    fill: "#51CDA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipses);
export default __webpack_public_path__ + "static/media/ellipses.8cdefe919ba79cc349c73075ed2b2802.svg";
export { ForwardRef as ReactComponent };